import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import reducer from '../reducers';
import { userInfo_local_storage_key } from '../helpers/common';
import { LOGIN_SUCCESS } from '../constants/actionTypes';

const middlewares = process.env.NODE_ENV === 'development' ? [thunk, logger] : [thunk];
const storedUser = localStorage.getItem(userInfo_local_storage_key);
const store = createStore(
  reducer,
  compose(
    applyMiddleware(...middlewares),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : args => args,
  ),
);



if (storedUser && storedUser !== "undefined") {
  try {
    store.dispatch({
      type: LOGIN_SUCCESS,
      payload: JSON.parse(storedUser),
    });
  } catch (error) {
    console.error("Invalid userInfo in localStorage:", error);
    localStorage.removeItem(userInfo_local_storage_key);
  }
}


export default store;
